<template>
  <div class="invitation" @click.stop v-if="showInvitation">
    <div class="content pa bg_fff">
    <!-- 广告 -->
      <div class="adv">
        <div class="title-container">
          <span class="iconfont iconshouquandanchuang-weixin" />
          <div class="title-text">
            <span>扫码添加客户经理</span><br/>
            <span>定制校招方案</span>
          </div>
        </div>
        <div class="main-container">
          <img src="https://files.wondercv.com/hr/adv_wechat1.png" alt="">
          <span class="desc">客户经理kiki</span>
          <span class="tips">扫一扫上面的二维码，加我微信</span>
        </div>
      </div>
      <div class="close iconfont iconquxiao color_90 cursor_p pa" @click="closeInvitaion();"></div>
      <div class="topContent">
        <div class="title f_18 color_fff font_w_b">“{{job_name || ''}}”发布成功</div>
        <div class="text f_14 color_fff">为您匹配了优质候选人，一键邀约即可批量发起沟通哦</div>
      </div>

      <div class="resumesList clearfix resetScrollBar">
        <div class="resume-box fl" v-for="(item,index) in resumesList" :key="index">
          <div data-growing-container :data-growing-idx="index" class="item flex pr cursor_p" @click="getDetail(item)">
            <img class="avatar" :src="item.resume.info.profile.avatar_url || headImgList.round[item.resume.user_id%5]" />
            <div class="cont flex1">

              <div class="nameBox ellipsis color_40 f_14">
                <span class="name color_40 f_18 font_w_b">{{item.resume.info.profile.username}}</span>
                <span class="" v-if="item.resume.info.profile.age">{{item.resume.info.profile.age}}岁</span>
                <span class="" v-if="workingYears({profession_identity: item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})">{{workingYears({profession_identity: item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at}) }}</span>
                <span class="" v-if="item.resume.info.profile.degree">{{item.resume.info.profile.degree}}</span>
                <!-- 期望薪资 -->
<!--                <span class="" v-if="expected_salary(item.resume.info.profile.expected_salary)">{{expected_salary(item.resume.info.profile.expected_salary)}}</span>-->
              </div>
              <div class="work-list">
                <!-- 公司 -->
                <template v-for="(items,index) in filterWork(item.resume.info.work_experiences, item.keyword_hit)" >
                  <div class="experienceItem flex schoolHtml ellipsis color_40 f_14" :key="String(index)" v-if="index<1">
                    <div class="icon-box" :style="`opacity: ${index === 0 ? 1 : 0}`">
                      <span class="iconfont iconGroup32 pr"></span>
                    </div>
                    <div class="experience-time">
                      <span v-if="items.start_at">{{splitTime(items.start_at.split(' ')[0])}}</span>
                      <span style="margin: 0 5px;"> - </span>
                      <span v-if="items.end_at">{{splitTime(items.end_at.split(' ')[0])}}</span>
                      <span v-if="!items.end_at && items.present">{{items.present}}</span>
                    </div>
                    <div class="flex1 f_14 color_40 afterText ellipsis">
                      <span v-if="items.company_name" v-html="items.company_name"></span>
                      <span v-if="items.title" v-html="items.title"></span>
                    </div>
                  </div>
                </template>
                <!-- 分割连线 -->
                <div class="line"></div>
                <!-- 学校/专业/学历 -->
                <div class="experienceItem flex schoolHtml ellipsis color_40 f_14" v-if="item.resume.info.education_experiences.length && checkEdu(item.resume.info.education_experiences, item.resume.info.basic_info.lang).length">
                  <div class="icon-box">
                    <span class="iconfont iconGroup12 pr"></span>
                  </div>
                  <div class="experience-time">
                    <span v-if="item.resume.info.education_experiences[0].start_at">{{splitTime(item.resume.info.education_experiences[0].start_at.split(' ')[0])}}</span>
                    <span style="margin: 0 2px;"> - </span>
                    <span v-if="item.resume.info.education_experiences[0].end_at">{{splitTime(item.resume.info.education_experiences[0].end_at.split(' ')[0])}}</span>
                  </div>
                  <div class="flex1 ellipsis" v-html="checkEdu(item.resume.info.education_experiences, item.resume.info.basic_info.lang)"></div>
                </div>
              </div>

            </div>
            <div class="checkState pa" @click.stop="resumesCheck(index)" :class="{'active': item.checked}">
              <span class="iconfont iconziyuanldpi" v-if="item.checked"></span>
<!--              <span class="border" v-else></span>-->
            </div>
          </div>
        </div>
      </div>

      <div class="templateButtons text_center">
        <div class="button cancelButton" @click="closeInvitaion();$router.push({path:'/talent/recommend', query: { token: $route.query.token }});">更多人才</div>
        
        <div class="button confirmButton disable" v-if='!checkResume.length'>一键邀约</div>
        <div class="button confirmButton" v-else @click="submitInvite"><span class="el-icon-loading" v-if="submitState"></span> 一键邀约</div>
      </div>
    </div>

    <!-- 简历详情 -->
    <recommendDetails @hideDetails="hideDetails" v-if="showDetail" />
  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapMutations, mapActions } from 'vuex'
//混入优化
import { mixinsUtils } from '@/mixins/search/utils';
import { get_tUser } from '@/utils/utils'
import { filterInfoSections, filterCustomSections, getAge, applied_at, getDegreeName, getWorkTimeLength } from '@/utils/resumeList';
import recommendDetails from '@/components/recommend/Details'

export default {
  name: 'invitation',
  mixins:[mixinsUtils],
  data(){
    return {
      showInvitation: false,
      job_name:'',
      submitData: {
        cv_tokens: [],
        job_id: '',
        apply_message: '',
        way: 'recommend', // search 搜索结果邀约 recommend 推荐结果邀约
        platform: 'pc_browser',

      },
      resumesList: [],
      submitState:false, //是否正在提交

      showDetail: false, //是否显示简历详情
    }
  },
  props:{
    jobToken:{},
  },
  computed:{
    // ...mapState('block',['userInfoState']),
    checkResume: function(){
      return this.resumesList.filter(item=> item.checked);
    },
    userToken () {
		  let { h_t } = get_tUser()
		  return h_t
	  }
  },
  components:{
    recommendDetails,
  },

  async created(){
    if(this.jobToken){
      //获取推荐列表
      this.getList();
      //获取打招呼语
      this.getGreetings();
    }
    document.body.style.position = 'static'
    document.body.style.overflow = 'hidden';
    // 获取用户信息
    this.getUserinfo();
  },
  beforeDestroy(){
    document.body.style.position = 'initial'
    document.body.style.overflow = 'initial'
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState']),
    ...mapMutations('resumeDetails',['updateResumeDetail', 'updateMyPosition','updateDownloadResumeInfo']),
    ...mapActions('resumeDetails',['getMyPosition']),
    // 获取用户信息
    async getUserinfo(){
      let userInfo = await actions.hr_accounts.getUserinfo({})
      this.toggleUserInfoState(userInfo);
    },
    //获取推荐列表
    getList(){
      actions.resumes.getRecommendAtions({token: this.jobToken}).then(res=>{
        if(res.code === 1000){
          console.log(res,"=================>res")
          let { all_rec_resumes } = res.data;
          if(all_rec_resumes.length && all_rec_resumes[0].rec_resumes.length){
            //保存职位名称
            this.job_name = all_rec_resumes[0].job_name;
            
            let resumesList = all_rec_resumes[0].rec_resumes;
            resumesList = resumesList.filter(item=> !item.hr_permission_state);
            resumesList.map(item=>{
              item.checked = true;
            })
            this.resumesList = resumesList;
            console.log(this.resumesList,"===================>resumesList")
            this.submitData.job_id = all_rec_resumes[0].job_id;

            if(resumesList.length){
              //显示弹窗
              this.showInvitation = true;
            }else{
              //关闭一键投递
              this.closeInvitaion();
            }

          }else{
            //关闭一键投递
            this.closeInvitaion();
          }
        }else{
          //关闭一键投递
          this.closeInvitaion();
        }
      })
    },
    //获取打招呼语
    getGreetings(){
      actions.im.getGreetings({ user_token: this.userToken }).then(res => {
      	if (res.code === 1000) {
          let { b_content, b_current_index } = res.data;
          this.submitData.apply_message = b_content[b_current_index]
        }
      })
    },
    // 切换选中状态
    resumesCheck(index){
      this.resumesList[index].checked = !this.resumesList[index].checked;
    },
    // 一键邀约
    submitInvite(){
      if(this.submitState){
        return
      }
      this.submitState = true;
      this.submitData.cv_tokens = this.checkResume.map(item=> item.resume.token);

      actions.resume_permissions.bulk_application(this.submitData).then(res=>{
        this.submitState = false;
        if(res.code === 1000){
          this.$message({
            message: '邀约成功！继续联系更多人才，获得回复更快一步',
            type: 'success'
          });
          this.closeInvitaion();
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
       
    },
    //关闭一键投递
    closeInvitaion(){
      //关闭页面弹窗
      this.showInvitation = false;
      this.$emit('closeInvitaion')
    },
    //【详情】获取简历详情
    async getDetail(item){
      this.updateDownloadResumeInfo(item)
      //获取职位列表
      this.getMyPosition();
      //更新页面数据
      this.updateResumeDetail(item);
      let resumeData = item.resume.info;

      //显示弹层
      this.showDetail = true;
      
    },
    //【详情】隐藏详情
    hideDetails(){
      this.showDetail = false;
    },

    //返回 满足条件的内容【有学校名称】
    checkEdu(education_experiences, lang){
      let html = '';
      let eduIndex = -1;
      education_experiences && education_experiences.forEach((item,index) => {
        if((item.cust_uni_name || item.school[lang]) && eduIndex<0){
          eduIndex = index;
        }
      });
      if(eduIndex>-1){
        html += `<span>${education_experiences[eduIndex].cust_uni_name || education_experiences[eduIndex].school[lang]}</span>`
        if(education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]){
          html += `<span>${education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]}</span>`
        }
        if(education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]){
          html += `<span>${education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]}</span>`
        }
      }
      if(html.length){
        html = "<div class='afterText' style='width:100%;'>"+ html
        html+="</div>"
      }
      return html
    },
    //过滤空公司信息
    filterWork(work_experiences, keyword_hit=[]){
      if(!work_experiences){
        return []
      }
      let workList = []
      work_experiences = JSON.parse(JSON.stringify(work_experiences));
      work_experiences.forEach(item=>{
        if(item.company_name || item.title){
          workList.push(item)
        }
      })
      return workList;
    },

  },
}
</script>
<style lang="scss" scoped>

@import './invitation.scss';

</style>
